const convertCharacterToNumber = (c: string) => {
  const cc = c.toUpperCase();
  if ('ABC'.includes(cc)) {
    return 2;
  } else if ('DEF'.includes(cc)) {
    return 3;
  } else if ('GHI'.includes(cc)) {
    return 4;
  } else if ('JKL'.includes(cc)) {
    return 5;
  } else if ('MNO'.includes(cc)) {
    return 6;
  } else if ('PQRS'.includes(cc)) {
    return 7;
  } else if ('TUV'.includes(cc)) {
    return 8;
  } else if ('WXYZ'.includes(cc)) {
    return 9;
  } else {
    return cc;
  }
};

export const convertNumberToCharacter = (n: number) => {
  if (n === 1) {
    return '';
  } else if (n === 2) {
    return 'ABC';
  } else if (n === 3) {
    return 'DEF';
  } else if (n === 4) {
    return 'GHI';
  } else if (n === 5) {
    return 'JKL';
  } else if (n === 6) {
    return 'MNO';
  } else if (n === 7) {
    return 'PQRS';
  } else if (n === 8) {
    return 'TUV';
  } else if (n === 9) {
    return 'WXYZ';
  } else if (n === 0) {
    return '+';
  }
};

export const getRealFromVanity = (vanity: string) => {
  const arr = vanity.split('');
  const realNums = arr.map((item, index) => convertCharacterToNumber(item));
  return realNums.join('');
};

export const convertToVanity = (num: string, key: string) => {
  const str = num.slice(2, num.length).replace(getRealFromVanity(key), key);
  const res = '(' + str.slice(0, 3) + ') ' + str.slice(3, 6) + '-' + str.slice(6, str.length);
  return res.replace(/([A-Z])-([A-Z])/g, '$1$2');
};

export const getOriginalNumber = (num: string) => {
  if (num.includes('+1')) {
    return '+' + num.replace(/\D/g, '');
  } else {
    return '+1' + num.replace(/\D/g, '');
  }
};

export const formatNumber = (num: string, vanity = '') => {
  if (!num) {
    return '';
  }
  if (vanity.length) {
    const str = num
      .slice(2, num.length)
      .replace(getRealFromVanity(vanity), vanity)
      .replace(getRealFromVanity(vanity), vanity);
    const res = '(' + str.slice(0, 3) + ') ' + str.slice(3, 6) + '-' + str.slice(6, str.length);
    return res.replace(/([A-Z])-([A-Z])/g, '$1$2');
  } else {
    return '(' + num.slice(2, 5) + ') ' + num.slice(5, 8) + '-' + num.slice(8, num.length);
  }
};

// TODO: Remove
export const getFormattedNumber = (num: string, vanity: string) => {
  if (!num) {
    return '';
  }
  if (vanity) {
    const str = num.slice(2, num.length).replace(getRealFromVanity(vanity), vanity);
    const res = '(' + str.slice(0, 3) + ') ' + str.slice(3, 6) + '-' + str.slice(6, str.length);
    return res.replace(/([A-Z])-([A-Z])/g, '$1$2');
  } else {
    return '(' + num.slice(2, 5) + ') ' + num.slice(5, 8) + '-' + num.slice(8, num.length);
  }
};
